import React from 'react';
import Icon from '../AppIcon';

const RegistrationProgressIndicator = ({ currentStep = 1, customSteps = null }) => {
  // Default steps for Team Registration Form
  const defaultSteps = [
    { id: 1, label: 'School & Coach', completed: currentStep > 1, active: currentStep === 1 },
    { id: 2, label: 'Coach Details', completed: currentStep > 2, active: currentStep === 2 },
    { id: 3, label: 'Player Registration', completed: currentStep > 3, active: currentStep === 3 },
    { id: 4, label: 'Captain Selection', completed: currentStep > 4, active: currentStep === 4 },
  ];

  // Use custom steps if provided, otherwise use default
  const steps = customSteps || defaultSteps;

  return (
    <div className="progress-indicator sticky top-4 z-20">
      <div className="hidden lg:flex progress-step">
        {steps?.map((step, index) => (
          <div key={step?.id} className="progress-step-item">
            <div
              className={`progress-step-circle ${
                step?.completed ? 'completed' : step?.active ? 'active' : 'pending'
              }`}
            >
              {step?.completed ? (
                <Icon name="Check" size={20} />
              ) : (
                <span>{step?.id}</span>
              )}
            </div>
            <span
              className={`progress-step-label ${
                step?.completed ? 'completed' : step?.active ? 'active' : 'pending'
              }`}
            >
              {step?.label}
            </span>
            {index < steps?.length - 1 && (
              <div
                className={`progress-step-line ${
                  step?.completed ? 'completed' : ''
                }`}
              />
            )}
          </div>
        ))}
      </div>
      <div className="lg:hidden flex flex-col gap-3">
        {steps?.map((step) => (
          <div
            key={step?.id}
            className={`flex items-center gap-3 p-3 rounded-md transition-all duration-200 ${
              step?.active ? 'bg-primary/10 border-l-4 border-primary' : 'bg-muted/50'
            }`}
          >
            <div
              className={`progress-step-circle ${
                step?.completed ? 'completed' : step?.active ? 'active' : 'pending'
              }`}
            >
              {step?.completed ? (
                <Icon name="Check" size={16} />
              ) : (
                <span>{step?.id}</span>
              )}
            </div>
            <span
              className={`progress-step-label ${
                step?.completed ? 'completed' : step?.active ? 'active' : 'pending'
              }`}
            >
              {step?.label}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RegistrationProgressIndicator;